// F4 Report 4: 2D and Material Selection
import React, { useEffect, useState } from "react";
import { fetchReport2DMaterial } from "../../api/service";
import ReportShell, { display, downloadReportCsv } from "./ReportShell";

const TwoDMaterialReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchReport2DMaterial()
      .then((res) => {
        if (!alive) return;
        setRows(res?.rows || []);
        setCount(res?.count || 0);
      })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <ReportShell
      title="4. 2D and Material Selection"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("2d_material")}
    >
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Sales</th>
              <th className="text-center">Design</th>
              <th className="text-center">Civil</th>
              <th className="text-center">Ageing (days)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={5} className="text-center text-muted py-4">No projects in this stage.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.sales_members)}</td>
                <td className="text-center">{display(r.design_members)}</td>
                <td className="text-center">{display(r.civil_members)}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default TwoDMaterialReport;
